import * as React from 'react';
import { useParams } from 'react-router-dom';

import { useFetchChannels } from '@/features/Channels/hooks/useFetchChannels';
import { useGetSearchId } from '@/hooks/useGetSearchId';

type RouteParams = {
  channelId?: string;
};

export const useCurrentChannel = () => {
  const { isLoading, isError, channels } = useFetchChannels();

  const { channel_id } = useGetSearchId(); // group feed
  const { channelId } = useParams<RouteParams>(); // group settings

  return React.useMemo(() => {
    if (isError || isLoading || !(channel_id || channelId)) {
      return {
        id: '',
        name: '',
        role: 'member',
        singlefeed: true,
        needl_feed: false,
      };
    }

    const channel = channels.find(
      (channel) => channel.id === (channelId || channel_id)
    );
    return channel || { id: '', name: '' };
  }, [channelId, channel_id, channels, isError, isLoading]);
};
